import React from 'react';
import { useTranslation } from 'react-i18next';
import './ViewToggle.css';

function ViewToggle({ viewMode, canToggle, setViewMode }) {
  const { t } = useTranslation();

  if (!canToggle) return null;

  return (
    <div className="view-toggle">
      <button
        className={`view-toggle-btn ${viewMode === 'kitchen' ? 'active' : ''}`}
        onClick={() => setViewMode('kitchen')}
      >
        <span className="view-toggle-icon">🍳</span>
        <span className="view-toggle-label">{t('views.kitchen')}</span>
      </button>
      <button
        className={`view-toggle-btn ${viewMode === 'bar' ? 'active' : ''}`}
        onClick={() => setViewMode('bar')}
      >
        <span className="view-toggle-icon">🍷</span>
        <span className="view-toggle-label">{t('views.bar')}</span>
      </button>
      <button
        className={`view-toggle-btn ${viewMode === 'waiter' ? 'active' : ''}`}
        onClick={() => setViewMode('waiter')}
      >
        <span className="view-toggle-icon">🍽️</span>
        <span className="view-toggle-label">{t('views.tables')}</span>
      </button>
    </div>
  );
}

export default ViewToggle;
